import React from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { StorySections } from '../components/StorySections';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { PricingSection } from '../components/PricingSection';
import { FAQGuaranteeSection } from '../components/FAQGuaranteeSection';
import { ClosingSection } from '../components/ClosingSection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function SalesPage() {
  return <div className="min-h-screen bg-bbq-dark font-sans text-gray-200 selection:bg-bbq-ember selection:text-white" data-id="element-184">
      <UrgencyBar data-id="element-185" />
      <main data-id="element-186">
        <HeroSection data-id="element-187" />
        <StorySections data-id="element-188" />
        <TestimonialsSection data-id="element-189" />
        <OfferSection data-id="element-190" />
        <PricingSection data-id="element-191" />
        <FAQGuaranteeSection data-id="element-192" />
        <ClosingSection data-id="element-193" />
      </main>
      <Footer data-id="element-194" />
      <RecentPurchaseToast data-id="element-195" />
    </div>;
}